
export default {
  esDesarrollo(state) {
    return state.modoDesarrollo == 'desarrollo';
  }
}